import { createSelector } from 'reselect';

import type { IApplicationState } from '../../../types/redux';
import { transformItem } from './transformItem';
import { transformSubItem } from './transformSubItem';
import { findByPathRecursive } from './findByPathRecursive';
import type { IMenuBlockItemsSchema } from '../../../repositories/journal/entities/menu/MenuBlockItemsSchema';
import type { IMenuMainItemV2Schema } from '../../../repositories/journal/entities/menu/MenuMainItemV2Schema';
import type { IMenuItemV2Schema } from '../../../repositories/journal/entities/menu/MenuItemV2Schema';

const selectMenuItems = (state: IApplicationState): IMenuBlockItemsSchema[] => state.menu.items;

/**
 * Фабрика селектора активного пункта/подпункта по pathname.
 * В компоненте оборачивать в useMemo(..., [pathname]) и передавать в useSelector —
 * иначе на каждом рендере будет новая функция-селектор (предупреждение react-redux).
 */
export const selectActiveItems = (pathname: string) =>
  createSelector([selectMenuItems], items => {
    const group = findByPathRecursive<IMenuBlockItemsSchema>(items, pathname);
    const item = group?.items && findByPathRecursive<IMenuMainItemV2Schema>(group.items, pathname);
    const subItem = item?.items && findByPathRecursive<IMenuItemV2Schema>(item.items, pathname);

    return {
      item: item && transformItem(item),
      subItem: subItem && transformSubItem(subItem),
    };
  });
